import { Identifiable, Resource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleEditRequest(
  resource: Identifiable<Resource>,
  { nextResource, resource: r }: Boundaries["editResource"]["request"],
): Identifiable<Resource> {
  return r.uuid === resource.uuid ? { ...resource, ...nextResource } : resource;
}

function handleEditSuccess(
  resource: Identifiable<Resource>,
  nextResource: Boundaries["editResource"]["success"],
): Identifiable<Resource> {
  return nextResource.uuid === resource.uuid ? nextResource : resource;
}

function handleEditFailure(
  resource: Identifiable<Resource>,
  { resource: r }: Boundaries["editResource"]["failure"],
): Identifiable<Resource> {
  return r.uuid === resource.uuid ? r : resource;
}

export { handleEditRequest, handleEditSuccess, handleEditFailure };
